export const toggleCookieHubWheel = ({ hide = false }) => {
  const cookieHubWheel = document.querySelector<HTMLDivElement>('.ch2-icon')

  if (cookieHubWheel && cookieHubWheel != null) {
    if (hide) {
      cookieHubWheel.style.display = 'none'
      return
    }

    cookieHubWheel.style.display = 'block'
  }


}
